import type { EditableComponent } from '../../common/model/types.tsx';
import { createOptions } from '../../common/rest/index.tsx';
import { getBaseUrl } from '../context/selectors.tsx';
import { getErrorFromResultJson } from '../errors.tsx';
import type { State } from '../reducer.tsx';
import { getEditedComponent, getId as getEditedId } from '../ui/edit/selectors.tsx';
import { componentEndpointUrl } from './index.tsx';

type UpdateComponent = (state: State) => Promise<EditableComponent | undefined>;

export const getComponentDataForRequest = (component?: EditableComponent) => {
	if (!component) return {};

	const { name, lead, defaultAssignee, description = '' } = component;

	return {
		name,
		description,
		assigneeType: defaultAssignee,
		leadAccountId: (lead && lead.accountId) || '',
	};
};

export const updateComponent: UpdateComponent = async (state) => {
	const componentId: string = getEditedId(state);
	const component: EditableComponent | undefined = getEditedComponent(state);
	const componentDataForRequest = getComponentDataForRequest(component);
	const fullUrl = `${getBaseUrl(state)}${componentEndpointUrl(componentId)}`;

	const result = await fetch(fullUrl, createOptions('PUT', componentDataForRequest));
	const resultJson = await result.json();

	if (result.ok) {
		return component;
	}
	throw getErrorFromResultJson(resultJson, result.status);
};
